import React from 'react';
import { Star } from 'lucide-react';
interface TestimonialProps {
  name: string;
  age: number;
  city: string;
  quote: string;
}
export function TestimonialCard({
  name,
  age,
  city,
  quote
}: TestimonialProps) {
  return <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100 flex flex-col h-full" data-id="element-235">
      <div className="flex items-center gap-1 mb-3" data-id="element-236">
        {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-237" />)}
      </div>
      <p className="text-gray-700 italic mb-4 flex-grow" data-id="element-238">"{quote}"</p>
      <div className="mt-auto flex items-center gap-3" data-id="element-239">
        <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-700 font-bold text-lg" data-id="element-240">
          {name.charAt(0)}
        </div>
        <div data-id="element-241">
          <p className="font-bold text-gray-900 text-sm" data-id="element-242">{name}</p>
          <p className="text-xs text-gray-500" data-id="element-243">
            {age} años, {city}
          </p>
        </div>
      </div>
    </div>;
}